var _path, _path2, _path3, _g, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _g5, _path0, _path1, _path10, _g6, _path11, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.792a8.829 8.829 0 0 1-8.829 8.828z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M70.62 88.277h88.28v335.45H70.62z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M150.069 126.526l-17.655 14.713H97.103l-17.655-14.713v-14.713l17.655-14.712h35.311l17.655 14.712z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73af00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.069 250.112l-17.655 14.714H97.103l-17.655-14.714V235.4l17.655-14.713h35.311l17.655 14.713zM150.069 188.319l-17.655 14.713H97.103l-17.655-14.713v-14.712l17.655-14.713h35.311l17.655 14.713zM150.069 311.905l-17.655 14.713H97.103l-17.655-14.713v-14.711l17.655-14.714h35.311l17.655 14.714z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.621 132.411l17.655 17.655-17.655 17.655zM158.896 167.721l-17.655-17.655 17.655-17.655zM70.621 194.204l17.655 17.655-17.655 17.655zM158.896 229.514l-17.655-17.655 17.655-17.655zM70.621 255.997l17.655 17.655-17.655 17.655zM158.896 291.307l-17.655-17.655 17.655-17.655zM70.621 317.79l17.655 17.655L70.621 353.1zM158.896 353.1l-17.655-17.655 17.655-17.655zM70.621 88.273h17.655l-17.655 17.655zM158.896 105.928l-17.655-17.655h17.655zM110.34 158.897h8.828v44.14h-8.828z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M97.1 176.547h35.31v8.828H97.1z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.241 166.25l-8.827-7.356v44.138l8.827-7.357zM88.276 195.675l8.827 7.357v-44.137l-8.827 7.355zM114.758 97.101H97.104l-17.656 14.712v7.357h35.31zM114.758 141.239h17.656l17.655-14.713v-7.356h-35.311z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M114.758 132.411l-17.655-13.189 17.655-13.294 17.656 13.294z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#73af00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.758 132.411l17.656-13.189-.069-.052h-17.587zM114.758 119.17v-13.242L97.173 119.17z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M97.1 229.517h35.31V256H97.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb400",
    d: "M132.41 238.337h8.828v8.828h-8.828z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M110.34 238.337h8.828v8.828h-8.828z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M110.34 291.307h8.828v8.828h-8.828z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.59 300.138h8.828v8.828h-8.828zM97.1 300.138h8.828v8.828H97.1z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M110.34 308.957h8.828v8.828h-8.828z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb400",
    d: "M88.28 238.337h8.828v8.828H88.28z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M150.069 373.698l-17.655 14.713H97.103l-17.655-14.713v-14.711l17.655-14.714h35.311l17.655 14.714z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.758 344.273H97.104l-17.656 14.713v7.356h35.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.758 388.411h17.656l17.655-14.713v-7.356h-35.311z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M132.414 370.755l-17.656 8.828-17.655-8.828v-8.827l17.655-8.828 17.656 8.828z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.01 136.34c-.94-.462-1.791.761-1.028 1.48 9.99 9.427 16.303 22.666 16.303 37.433 0 29.007-23.316 52.279-51.986 52.279a50.825 50.825 0 0 1-15.197-2.328c-.996-.311-1.641 1.025-.783 1.621 8.382 5.827 18.485 9.31 29.514 9.31 29.049 0 52.787-23.275 52.787-52.703-.001-20.682-12.14-38.503-29.61-47.092zM208.173 170.4l-2.159 6.109 5.08 4.021c.658.521.275 1.579-.564 1.557l-6.477-.167-2.254 6.074c-.292.787-1.417.749-1.655-.055l-1.843-6.211-6.474-.267c-.839-.034-1.15-1.116-.459-1.591l5.338-3.672-1.747-6.24c-.226-.808.706-1.439 1.372-.928l5.142 3.942 5.395-3.59c.696-.465 1.584.227 1.305 1.018zM234.407 183.65l-2.159 6.109 5.08 4.021c.658.521.275 1.579-.564 1.557l-6.477-.167-2.254 6.074c-.292.787-1.417.749-1.655-.055l-1.843-6.211-6.474-.267c-.839-.034-1.15-1.116-.459-1.591l5.338-3.672-1.747-6.24c-.226-.808.706-1.439 1.372-.928l5.142 3.942 5.395-3.59c.697-.464 1.584.228 1.305 1.018zM234.142 156.355l-2.159 6.109 5.08 4.021c.658.521.275 1.579-.564 1.557l-6.477-.167-2.254 6.074c-.292.787-1.417.749-1.655-.055l-1.843-6.211-6.474-.267c-.839-.034-1.15-1.116-.459-1.591l5.338-3.672-1.747-6.24c-.226-.808.706-1.439 1.372-.928l5.142 3.942 5.395-3.59c.697-.464 1.585.228 1.305 1.018zM235.036 130.01l-2.159 6.109 5.08 4.021c.658.521.275 1.579-.564 1.557l-6.477-.167-2.254 6.074c-.292.787-1.417.749-1.655-.055l-1.843-6.211-6.474-.267c-.839-.034-1.15-1.116-.459-1.591l5.338-3.672-1.747-6.24c-.226-.808.706-1.439 1.372-.928l5.142 3.942 5.395-3.59c.696-.465 1.584.227 1.305 1.018zM260.741 143.26l-2.159 6.109 5.08 4.021c.658.521.275 1.579-.564 1.557l-6.477-.167-2.254 6.074c-.292.787-1.417.749-1.655-.055l-1.843-6.211-6.474-.267c-.839-.034-1.15-1.116-.459-1.591l5.338-3.672-1.747-6.24c-.226-.808.706-1.439 1.372-.928l5.142 3.942 5.395-3.59c.696-.465 1.584.227 1.305 1.018z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.66860d71e79dda0b2c26c5468294bb05.svg";
export { ForwardRef as ReactComponent };